/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetProductCategoriesDocument = gql`
    query getProductCategories($id: Int, $branchId: Int!, $categoryName: String, $itemsPerPage: Int, $serviceDeleted: Boolean, $page: Int) {
  productCategories(
    id: $id
    branchId: $branchId
    categoryName: $categoryName
    itemsPerPage: $itemsPerPage
    page: $page
  ) {
    itemsPerPage
    currentPage
    pageCount
    totalCount
    items {
      id
      name
      comment
      deleted
      company {
        id
        name
        address
        phone
        website
        deleted
        bookingQrLink
        services {
          pageCount
        }
        isPremiumOn
        paidFeaturesPaginated {
          itemsPerPage
        }
      }
      products(deleted: $serviceDeleted) {
        id
        name
        deleted
        cost
        price
      }
      childCategories(name: $categoryName) {
        id
        name
        comment
        deleted
        company {
          id
          name
          address
          phone
          website
          deleted
          bookingQrLink
          isPremiumOn
          services {
            pageCount
          }
          paidFeaturesPaginated {
            itemsPerPage
          }
        }
        products(deleted: $serviceDeleted) {
          id
          name
          deleted
          cost
          price
        }
        parentCategory {
          id
          name
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      branchId: // value for 'branchId'
 *      categoryName: // value for 'categoryName'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      serviceDeleted: // value for 'serviceDeleted'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetProductCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables> & ({ variables: GetProductCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
      }
export function useGetProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
export function useGetProductCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
export type GetProductCategoriesQueryHookResult = ReturnType<typeof useGetProductCategoriesQuery>;
export type GetProductCategoriesLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesLazyQuery>;
export type GetProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetProductCategoriesSuspenseQuery>;
export type GetProductCategoriesQueryResult = Apollo.QueryResult<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export const UpdateProductCategoryInTableDocument = gql`
    mutation UpdateProductCategoryInTable($id: Int!, $input: ProductCategoryNewInput!, $branchId: Int!) {
  updateProductCategory(id: $id, input: $input, branchId: $branchId) {
    id
    name
    deleted
  }
}
    `;
export type UpdateProductCategoryInTableMutationFn = Apollo.MutationFunction<UpdateProductCategoryInTableMutation, UpdateProductCategoryInTableMutationVariables>;

/**
 * __useUpdateProductCategoryInTableMutation__
 *
 * To run a mutation, you first call `useUpdateProductCategoryInTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductCategoryInTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductCategoryInTableMutation, { data, loading, error }] = useUpdateProductCategoryInTableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateProductCategoryInTableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductCategoryInTableMutation, UpdateProductCategoryInTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductCategoryInTableMutation, UpdateProductCategoryInTableMutationVariables>(UpdateProductCategoryInTableDocument, options);
      }
export type UpdateProductCategoryInTableMutationHookResult = ReturnType<typeof useUpdateProductCategoryInTableMutation>;
export type UpdateProductCategoryInTableMutationResult = Apollo.MutationResult<UpdateProductCategoryInTableMutation>;
export type UpdateProductCategoryInTableMutationOptions = Apollo.BaseMutationOptions<UpdateProductCategoryInTableMutation, UpdateProductCategoryInTableMutationVariables>;
export const DeleteProductCategoryInTableDocument = gql`
    mutation DeleteProductCategoryInTable($productCategoryId: Int!, $branchId: Int!) {
  deleteProductCategory(
    productCategoryId: $productCategoryId
    branchId: $branchId
  ) {
    id
  }
}
    `;
export type DeleteProductCategoryInTableMutationFn = Apollo.MutationFunction<DeleteProductCategoryInTableMutation, DeleteProductCategoryInTableMutationVariables>;

/**
 * __useDeleteProductCategoryInTableMutation__
 *
 * To run a mutation, you first call `useDeleteProductCategoryInTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductCategoryInTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductCategoryInTableMutation, { data, loading, error }] = useDeleteProductCategoryInTableMutation({
 *   variables: {
 *      productCategoryId: // value for 'productCategoryId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useDeleteProductCategoryInTableMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductCategoryInTableMutation, DeleteProductCategoryInTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductCategoryInTableMutation, DeleteProductCategoryInTableMutationVariables>(DeleteProductCategoryInTableDocument, options);
      }
export type DeleteProductCategoryInTableMutationHookResult = ReturnType<typeof useDeleteProductCategoryInTableMutation>;
export type DeleteProductCategoryInTableMutationResult = Apollo.MutationResult<DeleteProductCategoryInTableMutation>;
export type DeleteProductCategoryInTableMutationOptions = Apollo.BaseMutationOptions<DeleteProductCategoryInTableMutation, DeleteProductCategoryInTableMutationVariables>;
export const RestoreProductCategoryInTableDocument = gql`
    mutation RestoreProductCategoryInTable($id: Int!, $input: ProductCategoryNewInput!, $branchId: Int!) {
  restoreProductCategory(id: $id, input: $input, branchId: $branchId) {
    id
    name
    deleted
  }
}
    `;
export type RestoreProductCategoryInTableMutationFn = Apollo.MutationFunction<RestoreProductCategoryInTableMutation, RestoreProductCategoryInTableMutationVariables>;

/**
 * __useRestoreProductCategoryInTableMutation__
 *
 * To run a mutation, you first call `useRestoreProductCategoryInTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProductCategoryInTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProductCategoryInTableMutation, { data, loading, error }] = useRestoreProductCategoryInTableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useRestoreProductCategoryInTableMutation(baseOptions?: Apollo.MutationHookOptions<RestoreProductCategoryInTableMutation, RestoreProductCategoryInTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreProductCategoryInTableMutation, RestoreProductCategoryInTableMutationVariables>(RestoreProductCategoryInTableDocument, options);
      }
export type RestoreProductCategoryInTableMutationHookResult = ReturnType<typeof useRestoreProductCategoryInTableMutation>;
export type RestoreProductCategoryInTableMutationResult = Apollo.MutationResult<RestoreProductCategoryInTableMutation>;
export type RestoreProductCategoryInTableMutationOptions = Apollo.BaseMutationOptions<RestoreProductCategoryInTableMutation, RestoreProductCategoryInTableMutationVariables>;
export const CreateProductCategoryInTableDocument = gql`
    mutation CreateProductCategoryInTable($companyId: Int!, $input: ProductCategoryNewInput!, $branchId: Int!) {
  createProductCategoryNew(
    companyId: $companyId
    input: $input
    branchId: $branchId
  ) {
    id
    name
    deleted
  }
}
    `;
export type CreateProductCategoryInTableMutationFn = Apollo.MutationFunction<CreateProductCategoryInTableMutation, CreateProductCategoryInTableMutationVariables>;

/**
 * __useCreateProductCategoryInTableMutation__
 *
 * To run a mutation, you first call `useCreateProductCategoryInTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductCategoryInTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductCategoryInTableMutation, { data, loading, error }] = useCreateProductCategoryInTableMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useCreateProductCategoryInTableMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductCategoryInTableMutation, CreateProductCategoryInTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductCategoryInTableMutation, CreateProductCategoryInTableMutationVariables>(CreateProductCategoryInTableDocument, options);
      }
export type CreateProductCategoryInTableMutationHookResult = ReturnType<typeof useCreateProductCategoryInTableMutation>;
export type CreateProductCategoryInTableMutationResult = Apollo.MutationResult<CreateProductCategoryInTableMutation>;
export type CreateProductCategoryInTableMutationOptions = Apollo.BaseMutationOptions<CreateProductCategoryInTableMutation, CreateProductCategoryInTableMutationVariables>;
export type GetProductCategoriesQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchId: Types.Scalars['Int']['input'];
  categoryName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  serviceDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetProductCategoriesQuery = { __typename?: 'Query', productCategories?: { __typename?: 'ProductCategoryNewPaginated', itemsPerPage?: number | null, currentPage?: number | null, pageCount?: string | null, totalCount?: number | null, items?: Array<{ __typename?: 'ProductCategoryNewProxy', id: number, name: string, comment?: string | null, deleted: boolean, company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, website?: string | null, deleted: boolean, bookingQrLink: string, isPremiumOn: boolean, services?: { __typename?: 'ServicePaginated', pageCount?: string | null } | null, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', itemsPerPage?: number | null } } | null, products?: Array<{ __typename?: 'ProductProxy', id: number, name: string, deleted: boolean, cost?: string | null, price: string }> | null, childCategories?: Array<{ __typename?: 'ProductCategoryNewProxy', id: number, name: string, comment?: string | null, deleted: boolean, company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, website?: string | null, deleted: boolean, bookingQrLink: string, isPremiumOn: boolean, services?: { __typename?: 'ServicePaginated', pageCount?: string | null } | null, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', itemsPerPage?: number | null } } | null, products?: Array<{ __typename?: 'ProductProxy', id: number, name: string, deleted: boolean, cost?: string | null, price: string }> | null, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null> | null }> | null } | null };

export type UpdateProductCategoryInTableMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  input: Types.ProductCategoryNewInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateProductCategoryInTableMutation = { __typename?: 'Mutation', updateProductCategory: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } };

export type DeleteProductCategoryInTableMutationVariables = Types.Exact<{
  productCategoryId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type DeleteProductCategoryInTableMutation = { __typename?: 'Mutation', deleteProductCategory: { __typename?: 'ProductCategoryNewProxy', id: number } };

export type RestoreProductCategoryInTableMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  input: Types.ProductCategoryNewInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type RestoreProductCategoryInTableMutation = { __typename?: 'Mutation', restoreProductCategory: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } };

export type CreateProductCategoryInTableMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.ProductCategoryNewInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type CreateProductCategoryInTableMutation = { __typename?: 'Mutation', createProductCategoryNew: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } };
